import { Column, defaultColActionDef, defaultColDef, formatter, TABLE_ACTION } from '@qrios/frontend-library';

import locales from '../../../../../../constants/commonLocales';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Operation Id',
    flex: 2
  },
  predefinedColumns.date({}),
  predefinedColumns.status({}),
  {
    ...defaultColDef,
    field: 'senderMsisdn',
    headerName: 'Sender',
    flex: 2
  },
  {
    ...defaultColDef,
    field: 'transferAmount',
    headerName: locales.table.column.amount,
    flex: 1,
    valueFormatter: formatter.amountFormatter
  },
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
